import useEmailSignup from '../useEmailSignup'
import Layout from '../Layout'

const LIST_ID = 'XLEfKM'

const Form = ({ onSuccess }: { onSuccess: () => void }) => {
  const {
    state: { serverError, errors },
    handlers: { handleSubmit, onSubmit, register },
    refs: { recaptchaRef },
  } = useEmailSignup(LIST_ID, onSuccess)

  return (
    <Layout
      onSubmit={handleSubmit(onSubmit)}
      recaptchaRef={recaptchaRef}
      formErrors={errors}
      serverError={serverError}
    >
      <div className="max-w-[400px] md:max-w-[600px] mx-auto flex flex-wrap justify-center md:justify-between items-center mt-8 mb-4">
        <input
          type="email"
          placeholder="Email Address"
          autoComplete="email"
          className="p-[10px] mb-10 md:mb-0 w-[80%] md:w-[60%] h-[44px] border rounded border-[#71717A] text-[16px] shadow-[0_4px_4px_rgba(0,0,0,0.25)] focus:border-[#3C7CB7] focus:ring-indigo-500 "
          {...register('email')}
        />
        <button
          type="submit"
          className="border h-[44px] border-[#3092A6] rounded-[3px] px-10 py-2 bg-[#3092A6] text-white text-[16px] font-extrabold  "
        >
          GET BIN UPDATES
        </button>
      </div>
    </Layout>
  )
}

export default Form
